(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-it-with"] && !Shopify.designMode) return;
  try {
    

function reorderSwatches(selectedSwatch){
  const styleWithProducts = Array.from(document.querySelectorAll('[data-parent-variant]'))
  styleWithProducts.forEach( (swp) => {
      const allOptions = Array.from(swp.querySelectorAll('[data-option-item]'));
      
      if(allOptions.length){
          const selectedLabel = selectedSwatch || swp.dataset.parentVariant;
          const optionsWrapper = allOptions[0].parentNode;
          const moreLabel = optionsWrapper.querySelector('.product-block-options__more-label')?.cloneNode(true);
          const swpThumbnails = swp.querySelectorAll('.product-block__image');
          const swpSwatches   = swp.querySelectorAll('.product-block-options__item');
          const lblsSelectedVariant = Array.from(document.querySelectorAll('.lblSelectedVariant'));
          
          // take only the options that have a matching swatch label
          const selectedOptions = allOptions.filter( opt => opt.dataset.optionItem == selectedLabel);
          // take only the options that DON'T have a matching swatch label
          const otherOptions = allOptions.filter( opt => opt.dataset.optionItem !== selectedLabel);
  
          let child = optionsWrapper.lastElementChild;
          while(child){
              optionsWrapper.removeChild(child);
              child = optionsWrapper.lastElementChild;
          }
          // loop through all the options
          [...selectedOptions, ...otherOptions].forEach( (opt, idx) => {
              // todo: truncation classes;
              if(idx < 3){
                  opt.classList.remove('product-block-options__item--truncated');
              } else {
                  opt.classList.add('product-block-options__item--truncated');
              }
              optionsWrapper.appendChild(opt);
          });
  
          if(moreLabel) optionsWrapper.appendChild(moreLabel);
          

          // update the active thumbnail
          setActiveImage(swp,selectedLabel);
        
          swpSwatches.forEach( swatch => {
            swatch.addEventListener('mouseover', (evt) => handleSwatchSelection(evt,swatch));
            swatch.addEventListener('click', (evt) => handleSwatchSelection(evt,swatch));
            
          })
          
      }
  })
  
}

  function setActiveImage(productEl,variantTitle){
    const images = Array.from(productEl.querySelectorAll('.product-block__image'));
    let _active;
    
    images.forEach( (el, idx) => {
      el.classList.toggle('product-block__image--show-on-hover',el.dataset.variantTitle === variantTitle);
      el.classList.toggle('product-block__image--active',el.dataset.variantTitle === variantTitle);
    })
    
  }
  
  function handleSwatchSelection(evt,thumb){
    
    evt.preventDefault();
    
    const optionsWrapper = evt.currentTarget.closest('.product-block-options');
    const productBlock = optionsWrapper.closest('.product-block');

    
    const { optionName } = optionsWrapper.dataset;
    const optionValue = evt.currentTarget.dataset.optionItem;
    // TODO: select active image
    setActiveImage(productBlock,optionValue);
    
    // include in URL
    Array.from(productBlock.querySelectorAll('.product-link, .quickbuy-toggle')).forEach((el) => {
      const url = new URL(el.href);
      const params = new URLSearchParams(url.search);
      params.set(optionName, optionValue);
      el.href = `${url.pathname}?${params}`;
      el.rel = 'nofollow';
    });
  }
  
document.addEventListener('on:variant:change', (event) => {
    var selectedVariant = event.detail.variant.title;
    var productItems = document.querySelectorAll('.product-block--style-with');
    var titleElement = document.querySelector('.stylewithtitle');

    // Handleize the selected variant title for class matching
    var handleizedVariant = 'variant_' + selectedVariant.replace(/\s+/g, '_').toLowerCase();

    // Hide title if no products
    var anyProductDisplayed = false;

    productItems.forEach(function (item) {
      if (item.classList.contains(handleizedVariant)) {
        item.style.display = 'block';
        anyProductDisplayed = true;
      } else {
        item.style.display = 'none';
      }
    });


    if (anyProductDisplayed) {
      titleElement.style.display = 'block';
    } else {
      titleElement.style.display = 'none';
    }
    /* reorder the style-it-with swatches */
    reorderSwatches(selectedVariant);
  });

document.addEventListener("shopify:section:visible", () => {
  console.log("Section Loaded: Style it With")
})
  /* reorder the style-it-with swatches */
  reorderSwatches();


  } catch(e) { console.error(e); }
})();
})();
